/* Bioteine - Collection Load-More / Infinite Scroll
 * Fetches the next page via Shopify's Section Rendering API and appends
 * the new product cards to the existing grid.
 */
(function () {
  'use strict';

  function init(wrap) {
    if (wrap.dataset.btLoadmoreInited === '1') return;
    wrap.dataset.btLoadmoreInited = '1';

    var mode = wrap.dataset.mode; // 'load_more' or 'infinite'
    var sectionId = wrap.dataset.sectionId;
    var btn = wrap.querySelector('[data-bt-loadmoreBtn], [data-bt-loadmore-btn]');
    var shownEl = wrap.querySelector('[data-bt-loadmore-shown]');
    var meta = wrap.querySelector('[data-bt-loadmore-meta]');
    var nextUrl = wrap.dataset.nextUrl;
    var loading = false;

    var grid = document.querySelector('[data-bt-grid]');
    if (!grid) return;

    function pageFromUrl(url) {
      try {
        var u = new URL(url, window.location.origin);
        return parseInt(u.searchParams.get('page') || '1', 10);
      } catch (e) { return 1; }
    }

    function buildSectionUrl(url) {
      // Append section_id so we get only the section HTML back
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      return u.toString();
    }

    function fetchNext() {
      if (loading || !nextUrl) return;
      loading = true;
      if (btn) {
        btn.disabled = true;
        btn.dataset.originalText = btn.dataset.originalText || btn.textContent;
        btn.textContent = 'Bezig met laden...';
      }

      fetch(buildSectionUrl(nextUrl), { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          // Extract the new grid's product cards
          var newGrid = doc.querySelector('[data-bt-grid]');
          if (newGrid) {
            // Don't append spotlight blocks (they only render on page 1)
            var newCards = newGrid.querySelectorAll('.bt-product-card, article:not(.bt-collection-spotlight)');
            newCards.forEach(function (card) {
              grid.appendChild(card);
            });
          }

          // Update next URL + page state from the response's loadmore wrap
          var newWrap = doc.querySelector('[data-bt-loadmore]');
          nextUrl = newWrap ? newWrap.dataset.nextUrl : '';
          if (newWrap && shownEl) {
            var newShown = newWrap.querySelector('[data-bt-loadmore-shown]');
            if (newShown) shownEl.textContent = newShown.textContent;
          }

          if (!nextUrl && btn) {
            // No more pages: remove the button
            btn.remove();
          } else if (btn) {
            btn.disabled = false;
            btn.textContent = btn.dataset.originalText || 'Laad meer producten';
          }
          loading = false;
        })
        .catch(function () {
          loading = false;
          if (btn) {
            btn.disabled = false;
            btn.textContent = 'Probeer opnieuw';
          }
        });
    }

    if (mode === 'load_more' && btn) {
      btn.addEventListener('click', fetchNext);
    }

    if (mode === 'infinite') {
      // Auto-trigger when wrap enters viewport
      if (btn) btn.style.display = 'none';
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) fetchNext();
        });
      }, { rootMargin: '400px 0px' });
      io.observe(wrap);
    }
  }

  function initPerPagePref() {
    var toolbar = document.querySelector('[data-bt-grid-toolbar]');
    if (!toolbar) return;
    var chips = toolbar.querySelectorAll('[data-bt-pp]');
    if (!chips.length) return;

    var KEY = 'bt_per_page';
    // On click: save preference. The link itself navigates to ?view=N.
    chips.forEach(function (a) {
      a.addEventListener('click', function () {
        try { localStorage.setItem(KEY, a.getAttribute('data-bt-pp')); } catch (e) {}
      });
    });

    // On first paint: if saved preference differs from current URL view, redirect.
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (!saved) return;

    var url = new URL(window.location.href);
    var currentView = url.searchParams.get('view') || '96';
    if (currentView === saved) return;

    // Build target URL: preserve other params except view
    if (saved === '96') {
      url.searchParams.delete('view');
    } else {
      url.searchParams.set('view', saved);
    }
    url.searchParams.delete('page'); // reset page on per-page change
    // Use replaceState-style navigation to avoid polluting history
    window.location.replace(url.toString());
  }

  function initColToggle() {
    var toolbar = document.querySelector('[data-bt-grid-toolbar]');
    if (!toolbar) return;
    var grid = document.querySelector('[data-bt-grid]');
    if (!grid) return;

    // Restore last choice from localStorage
    var saved = parseInt(localStorage.getItem('bt_grid_cols') || '0', 10);
    if (saved >= 2 && saved <= 5) applyCols(saved);
    else markCurrentFromGrid();

    function applyCols(n) {
      grid.className = grid.className.replace(/bt-product-grid--\d+/g, '');
      grid.classList.add('bt-product-grid--' + n);
      toolbar.querySelectorAll('[data-bt-cols]').forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.dataset.btCols, 10) === n);
      });
      try { localStorage.setItem('bt_grid_cols', String(n)); } catch (e) {}
    }
    function markCurrentFromGrid() {
      var match = grid.className.match(/bt-product-grid--(\d+)/);
      var n = match ? parseInt(match[1], 10) : 4;
      toolbar.querySelectorAll('[data-bt-cols]').forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.dataset.btCols, 10) === n);
      });
    }

    toolbar.querySelectorAll('[data-bt-cols]').forEach(function (b) {
      b.addEventListener('click', function () {
        applyCols(parseInt(b.dataset.btCols, 10));
      });
    });
  }

  function initAll() {
    initPerPagePref();
    document.querySelectorAll('[data-bt-loadmore]').forEach(init);
    initColToggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
